"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Language = Language;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const iso_639_1_1 = __importDefault(require("iso-639-1"));
const renderer_1 = require("@react-pdf/renderer");
const ApplicantProfilePDF_styles_1 = require("./ApplicantProfilePDF.styles");
function checkLanguageTranslation(language_code, languageTranslations) {
    var _a;
    return (_a = languageTranslations.languages.filter(lang => lang.code === language_code)[0]) === null || _a === void 0 ? void 0 : _a.value;
}
function Language({ languages, config }) {
    if (!languages) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: languages.map(language => {
            const languageTranslation = checkLanguageTranslation(language.language_code, config);
            return ((0, jsx_runtime_1.jsxs)(renderer_1.View, { style: ApplicantProfilePDF_styles_1.styles.tableRow, children: [(0, jsx_runtime_1.jsx)(renderer_1.Text, { style: ApplicantProfilePDF_styles_1.styles.languageText, children: languageTranslation || iso_639_1_1.default.getNativeName(language.language_code) }), (0, jsx_runtime_1.jsx)(renderer_1.Text, { style: ApplicantProfilePDF_styles_1.styles.languageText, children: language.level })] }, language.id));
        }) }));
}
